<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
      @show="resetModal"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input id="id-input" v-model="formValues.id" autocomplete="off" disabled />
        </b-form-group>

        <b-form-group label="Blocked" label-for="blocked-input">
          <b-form-select v-model="formValues.blocked" :options="blockedOptions" required />
        </b-form-group>

        <b-form-group label="Order" label-for="order-input">
          <b-form-input
            id="order-input"
            type="number"
            v-model="formValues.order"
            v-validate="{ required: true, numeric: true }"
            :state="validateState('order')"
            aria-describedby="order-live-feedback"
            data-vv-name="order"
            data-vv-as="Order"
            autocomplete="off"
            placeholder="0"
            required
          />
          <b-form-invalid-feedback id="order-live-feedback">{{ veeErrors.first('order') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Domain" label-for="domain-input">
          <b-form-input
            id="domain-input"
            type="text"
            v-model="formValues.domain"
            v-validate="{ required: true }"
            :state="validateState('domain')"
            aria-describedby="domain-live-feedback"
            data-vv-name="domain"
            data-vv-as="Domain"
            autocomplete="off"
            required
          />
          <b-form-invalid-feedback id="domain-live-feedback">{{ veeErrors.first('domain') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="useTimesAggr" label-for="useTimesAggr-input">
          <b-form-input
            id="useTimesAggr-input"
            type="number"
            v-model="formValues.useTimesAggr"
            v-validate="{ numeric: true }"
            :state="validateState('useTimesAggr')"
            aria-describedby="useTimesAggr-live-feedback"
            data-vv-name="useTimesAggr"
            data-vv-as="useTimesAggr"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="useTimesAggr-live-feedback">{{ veeErrors.first('useTimesAggr') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="useTimesProxy" label-for="useTimesProxy-input">
          <b-form-input
            id="useTimesProxy-input"
            type="number"
            v-model="formValues.useTimesProxy"
            v-validate="{ numeric: true }"
            :state="validateState('useTimesProxy')"
            aria-describedby="useTimesProxy-live-feedback"
            data-vv-name="useTimesProxy"
            data-vv-as="useTimesProxy"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="useTimesProxy-live-feedback">{{ veeErrors.first('useTimesProxy') }}</b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      blockedOptions: [
        { value: false, text: 'false' },
        { value: true, text: 'true' },
      ],
    }
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        __v: 0,
        blocked: false,
        country: null,
        domain: null,
        order: 0,
        useTimesAggr: 0,
        useTimesProxy: 0,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();
      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }
      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      for (let key of Object.keys(this.formValues)) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = this.formValues[key].trim();
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
          .$http({
            url: this.create ? '/api/v1/proxy-country-use' : '/api/v1/proxy-country-use/' + this.formValues.id,
            data: {
              __v: Number.parseInt(this.formValues.__v ?? 0),
              blocked: !!this.formValues.blocked,
              country: (this.formValues.country ?? '').toUpperCase(),
              domain: this.formValues.domain,
              order: Number.parseInt(this.formValues.order ?? 0),
              useTimesAggr: Number.parseInt(this.formValues.useTimesAggr ?? 0),
              useTimesProxy: Number.parseInt(this.formValues.useTimesProxy ?? 0),
            },
            method: this.create ? 'POST' : 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish');
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            let message;
            if (typeof err.response.data.message === 'string') {
              message = err.response.data.message;
            } else {
              message = JSON.stringify(err.response.data.message);
            }
            this.$toastr.e(message);
            throw err;
          });
      });
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>

